(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    var marquee = document.querySelector("[data-infinite-text]");
    if (marquee && window.gsap && window.ScrollTrigger) {
      var textRows = marquee.querySelectorAll(".portfolio__marquee-text");
      window.gsap.set(textRows, { xPercent: 0 });

      var tl = window.gsap.to(textRows, {
        xPercent: -50,
        duration: 20,
        ease: "none",
        repeat: -1
      });

      window.ScrollTrigger.create({
        trigger: marquee,
        start: "top 85%",
        end: "bottom 15%",
        invalidateOnRefresh: true,
        onUpdate: function (self) {
          tl.timeScale(self.direction === 1 ? 1 : -1);
        }
      });
    }

    var magneticButtons = document.querySelectorAll("[data-magnetic]");
    magneticButtons.forEach(function (button) {
      button.addEventListener("mousemove", function (event) {
        var rect = button.getBoundingClientRect();
        var relX = (event.clientX - rect.left - rect.width / 2) / rect.width;
        var relY = (event.clientY - rect.top - rect.height / 2) / rect.height;
        var x = relX * 16;
        var y = relY * 16;
        button.style.transform = "translate(" + x + "px, " + y + "px)";
      });

      button.addEventListener("mouseleave", function () {
        button.style.transform = "";
      });
    });

    var list = document.querySelector("[data-portfolio-list]");
    var moreButton = document.querySelector("[data-portfolio-more]");
    if (!list) {
      return;
    }

    var isLinkMoreButton =
      moreButton && moreButton.tagName && moreButton.tagName.toLowerCase() === "a";
    var linkButtonShown = false;

    var perPage = 7;
    var currentIndex = 0;
    var items = [];
    var isLoading = false;
    var hasMore = true;
    var revealQueue = [];
    var revealRunning = false;
    var portfolioInView = false;
    var revealAfterLoadPending = false;

    var showLinkButton = function () {
      if (!isLinkMoreButton || !moreButton || linkButtonShown) {
        return;
      }
      linkButtonShown = true;
      moreButton.classList.remove("portfolio__more--hidden");
      moreButton.removeAttribute("aria-hidden");
    };

    var hideLinkButton = function () {
      if (!isLinkMoreButton || !moreButton) {
        return;
      }
      moreButton.classList.add("portfolio__more--hidden");
      moreButton.setAttribute("aria-hidden", "true");
    };

    var hideMoreButton = function () {
      if (!moreButton) {
        return;
      }
      if (isLinkMoreButton) {
        showLinkButton();
        return;
      }
      moreButton.setAttribute("disabled", "disabled");
      moreButton.style.display = "none";
    };

    var applyTextAnimations = function (scope) {
      if (window.DNB && typeof window.DNB.textOpacityInit === "function") {
        window.DNB.textOpacityInit(scope);
      }
      if (window.DNB && typeof window.DNB.textOpacityV2Init === "function") {
        window.DNB.textOpacityV2Init(scope);
      }
    };

    var revealBodyText = function (card, onComplete) {
      if (!card) {
        if (typeof onComplete === "function") {
          onComplete();
        }
        return;
      }

      var targets = Array.prototype.slice.call(
        card.querySelectorAll(
          ".portfolio-card__title, .portfolio-card__desc, .portfolio-card__tags li"
        )
      ).filter(function (el) {
        if (el.dataset.dnbRevealPlayed === "true") {
          return false;
        }
        el.dataset.dnbRevealPlayed = "true";
        return true;
      });

      var finalize = function () {
        targets.forEach(function (target) {
          var inner = target.querySelector(".dnb-reveal__inner");
          if (inner) {
            inner.style.opacity = "";
            inner.style.transform = "";
          } else {
            target.style.opacity = "";
            target.style.transform = "";
          }
        });
        if (typeof onComplete === "function") {
          onComplete();
        }
      };

      if (!targets.length || !window.DNB || typeof window.DNB.revealText !== "function") {
        finalize();
        return;
      }

      var timeline = window.DNB.revealText(targets, {
        duration: 0.3,
        stagger: 0,
        ease: "expo.out",
        onComplete: finalize
      });

      if (!timeline) {
        finalize();
      }
    };

    var prepareBodyReveal = function (card) {
      if (!card || !window.DNB || typeof window.DNB.prepareReveal !== "function") {
        return;
      }

      var targets = card.querySelectorAll(
        ".portfolio-card__title, .portfolio-card__desc, .portfolio-card__tags li"
      );
      targets.forEach(function (target) {
        if (target.dataset.dnbRevealPrepared === "true") {
          return;
        }
        target.dataset.dnbRevealPrepared = "true";
        var inner = window.DNB.prepareReveal(target);
        if (inner) {
          inner.style.opacity = "0";
        }
      });
    };

    var runRevealBatch = function (targets) {
      if (!targets.length) {
        revealRunning = false;
        showLinkButton();
        return;
      }

      if (!window.gsap) {
        targets.forEach(function (target) {
          target.style.opacity = "";
          target.style.transform = "";
          var mediaContent = target.querySelector(".portfolio-card__media-content");
          if (mediaContent) {
            mediaContent.style.transform = "";
          }
        });
        revealRunning = false;
        return;
      }

      var revealNext = function (index) {
        if (index >= targets.length) {
          revealRunning = false;
          showLinkButton();
          if (revealQueue.length) {
            startReveal();
          }
          return;
        }

        var target = targets[index];
        var mediaContent = target.querySelector(".portfolio-card__media-content");
        window.gsap.to(target, {
          opacity: 1,
          scale: 1,
          duration: 0.3,
          ease: "power3.out",
          onComplete: function () {
            revealBodyText(target.closest(".portfolio-card"), function () {
              revealNext(index + 1);
            });
          }
        });

        if (mediaContent) {
          window.gsap.to(mediaContent, {
            scale: 1,
            duration: 0.3,
            ease: "power3.out"
          });
        }
      };

      revealNext(0);
    };

    var startReveal = function () {
      if (
        !revealAfterLoadPending &&
        window.DNB &&
        !window.DNB.loadingComplete &&
        typeof window.DNB.onLoadComplete === "function"
      ) {
        revealAfterLoadPending = true;
        window.DNB.onLoadComplete(function () {
          revealAfterLoadPending = false;
          startReveal();
        });
        return;
      }

      if (revealRunning || !portfolioInView || !revealQueue.length) {
        return;
      }

      revealRunning = true;
      var batch = revealQueue.slice();
      revealQueue = [];
      runRevealBatch(batch);
    };

    var queueReveal = function (targets) {
      if (!targets || !targets.length) {
        return;
      }

      var newTargets = [];
      targets.forEach(function (target) {
        if (target.dataset.portfolioRevealQueued === "true") {
          return;
        }
        target.dataset.portfolioRevealQueued = "true";
        if (window.gsap) {
          target.style.opacity = "0";
          target.style.transform = "scale(0.3)";
          target.style.transformOrigin = "center";
          var mediaContent = target.querySelector(".portfolio-card__media-content");
          if (mediaContent) {
            mediaContent.style.transform = "scale(3.0)";
            mediaContent.style.transformOrigin = "center";
          }
        }
        newTargets.push(target);
      });

      if (!newTargets.length) {
        return;
      }

      revealQueue = revealQueue.concat(newTargets);
      startReveal();
    };

    var normalizeList = function (value) {
      if (Array.isArray(value)) {
        return value
          .map(function (entry) {
            return String(entry || "").trim();
          })
          .filter(Boolean);
      }
      if (typeof value === "string") {
        return value
          .split(",")
          .map(function (entry) {
            return String(entry || "").trim();
          })
          .filter(Boolean);
      }
      return [];
    };

    var normalizeSize = function (value) {
      var size = value ? String(value).trim().toLowerCase() : "";
      if (size === "small" || size === "medium" || size === "large") {
        return size;
      }
      return "medium";
    };

    var isVideoFile = function (value) {
      return String(value || "").toLowerCase().endsWith(".mp4");
    };

    var getMediaInfo = function (item) {
      if (!item) {
        return null;
      }

      if (item.video) {
        var videoSrc = String(item.video || "").trim();
        if (videoSrc) {
          return { src: videoSrc, isVideo: true };
        }
      }

      if (item.image) {
        var imageSrc = String(item.image || "").trim();
        if (imageSrc) {
          return { src: imageSrc, isVideo: false };
        }
      }

      if (Array.isArray(item.images) && item.images.length) {
        var first = String(item.images[0] || "").trim();
        if (first) {
          return { src: first, isVideo: isVideoFile(first) };
        }
      }

      if (item.images) {
        var fallback = String(item.images || "").trim();
        if (fallback) {
          return { src: fallback, isVideo: isVideoFile(fallback) };
        }
      }

      return null;
    };

    var resolveMediaSrc = function (src, isVideo) {
      var lower = String(src || "").toLowerCase();
      var hasPath = /^[a-z]+:\/\//.test(lower) || String(src).indexOf("/") !== -1;
      var basePath = isVideo ? "/assets/videos/" : "/assets/images/";
      return hasPath ? src : basePath + src;
    };

    var createCard = function (item) {
      var url = item && item.url ? String(item.url || "").trim() : "";
      var article = url ? document.createElement("a") : document.createElement("article");
      article.className = "portfolio-card";
      article.classList.add(normalizeSize(item && item.size));
      if (url) {
        article.href = url;
        if (item && item.title) {
          article.setAttribute("aria-label", item.title);
        }
      }

      var media = document.createElement("div");
      media.className = "portfolio-card__media";
      media.setAttribute("aria-hidden", "true");

      var mediaInfo = getMediaInfo(item);
      var hasFiles = !!(mediaInfo && mediaInfo.src);
      if (!hasFiles && item && item.mediaClass) {
        var mediaClass = String(item.mediaClass || "").trim();
        if (mediaClass && mediaClass.indexOf(" ") === -1 && mediaClass.indexOf(",") === -1) {
          media.classList.add(mediaClass);
        }
      }

      if (hasFiles) {
        var src = resolveMediaSrc(mediaInfo.src, mediaInfo.isVideo);
        if (mediaInfo.isVideo) {
          var video = document.createElement("video");
          video.className = "portfolio-card__media-content";
          video.src = src;
          video.autoplay = true;
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          video.preload = "metadata";
          media.appendChild(video);
        } else {
          var img = document.createElement("img");
          img.className = "portfolio-card__media-content";
          img.src = src;
          img.alt = item.title || "";
          img.loading = "lazy";
          img.decoding = "async";
          media.appendChild(img);
        }
      } else {
        media.style.background =
          "#000000";
          //"linear-gradient(140deg,#062420 0,#0b2f2a 45%,#0f3a33 100%)";
      }
      if (item && item.bgColor) {
        media.style.background = item.bgColor;
      }

      // Etiketler  Açıldı
      var tagsList = normalizeList(item && item.tags);
      if (tagsList.length) {
        var tags = document.createElement("ul");
        tags.className = "portfolio-card__tags";
        tagsList.forEach(function (tag) {
          var li = document.createElement("li");
          li.textContent = tag;
          tags.appendChild(li);
        });
        media.appendChild(tags);
      }

      var body = document.createElement("div");
      body.className = "portfolio-card__body";

      if (item && item.title) {
        var title = document.createElement("h3");
        title.className = "portfolio-card__title";
        //title.setAttribute("data-text-opacity-v2", "");
        title.textContent = item.title;
        body.appendChild(title);
      }

      if (item && item.description) {
        var desc = document.createElement("p");
        desc.className = "portfolio-card__desc";
        //desc.setAttribute("data-text-opacity", "");
        desc.innerHTML = String(item.description || "");
        body.appendChild(desc);
      }

      

      article.appendChild(media);
      article.appendChild(body);
      prepareBodyReveal(article);
      return article;
    };

    var renderNext = function () {
      if (!items.length) {
        return;
      }

      var nextItems = items.slice(currentIndex, currentIndex + perPage);
      if (!nextItems.length) {
        hasMore = false;
        hideMoreButton();
        return;
      }

      var fragment = document.createDocumentFragment();
      nextItems.forEach(function (item) {
        fragment.appendChild(createCard(item));
      });
      list.appendChild(fragment);
      currentIndex += nextItems.length;

      if (currentIndex >= items.length) {
        hasMore = false;
        hideMoreButton();
      }

      applyTextAnimations(list);
      var newMedia = Array.prototype.slice.call(
        list.querySelectorAll(".portfolio-card__media")
      );
      queueReveal(newMedia);
      if (!newMedia.length) {
        showLinkButton();
      }
      window.requestAnimationFrame(function () {
        if (window.ScrollTrigger) {
          window.ScrollTrigger.refresh();
        }
        if (window.DNB && window.DNB.locoScroll) {
          window.DNB.locoScroll.update();
        }
      });
    };

    if (window.gsap && window.ScrollTrigger) {
      var revealTrigger = {
        trigger: list,
        start: "top 80%",
        invalidateOnRefresh: true,
        once: true,
        onEnter: function () {
          portfolioInView = true;
          startReveal();
        }
      };

      if (window.DNB && window.DNB.scroller) {
        revealTrigger.scroller = window.DNB.scroller;
      }

      window.ScrollTrigger.create(revealTrigger);
    } else if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              portfolioInView = true;
              startReveal();
              observer.disconnect();
            }
          });
        },
        { threshold: 0.3 }
      );

      observer.observe(list);
    } else {
      portfolioInView = true;
    }

    var loadData = function () {
      if (isLoading) {
        return;
      }
      isLoading = true;

      //fetch("assets/data/portfolio.json")
      // console.log("[loader] fetch start", "/Works-service");
      var request = fetch("/Works-service") 
        .then(function (response) {
          if (!response.ok) { 
            throw new Error("Portfolio data not found");
          }
          return response.json();
        })
        .then(function (data) {
          // console.log("[loader] fetch success", "/Works-service", {
          //   items: Array.isArray(data && data.data) ? data.data.length : null
          // });
          if (!Array.isArray(data.data)) { 
            hasMore = false;
            hideMoreButton();
            return;
          }
          items = data.data;
          if (!items.length) {
            showLinkButton();
          }
          renderNext();
        })
        .catch(function (error) {
          // console.log("[loader] fetch failed", "/Works-service", error);
          hasMore = false;
          hideMoreButton();
        })
        .finally(function () {
          isLoading = false;
        });

      if (window.DNB && typeof window.DNB.registerLoadTask === "function") {
        window.DNB.registerLoadTask(request);
      }
    };

    loadData();

    if (moreButton) {
      if (isLinkMoreButton) {
        hideLinkButton();
      }
    }

    if (moreButton && !isLinkMoreButton) {
      moreButton.addEventListener("click", function (event) {
        event.preventDefault();
        if (isLoading || !hasMore) {
          return;
        }
        renderNext();
      });
    }
  });
})();
